import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { LoginUserDTO } from '../data/LoginUserDTO';
import { TokenDTO } from '../data/TokenDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { UserDTO } from '../../../users/api/data/UserDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthProvider {
  private header=APIService.getHeader();
  itemret:any;

  constructor(public http: HttpClient,
        private translate: TranslateService,

  ) {
  }

  /**
   * Login using username and password (Agency)
   * @param userName 
   * @param password 
   * @returns 
   */
  login(userName:string, password:string) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "operation":"login",
        "userName":userName,
        "password":password
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => {
          var jsonData:LoginUserDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        } 
      })
    });

  }

  
  /**
   * AD Authentication (Globo and Affiliates)
   * @param tokenAD The token received from AD authentication
   * @returns A promise that resolves with the authentication result
   */
  authAD(tokenAD:string) {
    ////console.log('tokenAd Microsoft:', tokenAD);

    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'login';
      var data = {
        "operation":"loginad",
        "tokenad":tokenAD
      }
      var requestData=JSON.stringify(data);
      // //console.log(requestData);
      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => {
          var jsonData:LoginUserDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        } 
      })
    });

  }

  generateToken(name?: string, email?:string) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "name": name,
        "userName":email,
        "email":email
        };

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'token';

      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => {
          var jsonData:TokenDTO = response;
          resolve(jsonData);
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        } 
      })
    });

  }

  forgotPassword(email?: string, password?: string) {
    var me=this;
    this.header=APIService.getHeaderResetPassword();

    return new Promise((resolve, reject) => {
      var data:any = {
        "operation":"resetpassword"
      };

      if (email) {
        data.email = email;
      }

      if (password) {
        data.password = password;
      }

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => {
          var jsonData:TokenDTO = response;
          resolve(jsonData);
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        } 
      })
    });
  }

  resetPassword(password?: string) {
    var me=this;
    this.header=APIService.getHeaderResetPassword();

    return new Promise((resolve, reject) => {
      var data:any = {
        "operation":"updatepassword"
      };

      if (password) {
        data.newPassword = password;
      }

      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';

      this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (response) => {
          var jsonData:UserDTO = response;
          resolve(jsonData);
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        } 
      })
    });
  }
}
